const homeBannerSlider = new Swiper('.homeBannerSection .homeBanner', {
  slidesPerView:1,
  spaceBetween:10,
  loop:true,
  /*pagination:{el:'.swiper-pagination',clickable:true},*/
  navigation:{nextEl:'.swiper-button-next',prevEl:'.swiper-button-prev'},
  autoplay:{delay:4000,disableOnInteraction:false},
});
/*----*/
/* FAQ */
function toggleAccordion(el) {
  const item = el.closest('.accordion-item');
  const content = item.querySelector(':scope > .accordion-content');
  const container = el.closest('.accordion-content') || el.closest('.accordion-main');

  const isActive = item.classList.contains('active');

  // Close siblings (same level)
  container.querySelectorAll(':scope > .accordion-item').forEach(i => {
    if (i !== item) {
      i.classList.remove('active');
      const c = i.querySelector(':scope > .accordion-content');
      if (c) c.style.height = '0px';
    }
  });

  // Toggle current
  if (isActive) {
    item.classList.remove('active');
    if (content) content.style.height = '0px';
  } else {
    item.classList.add('active');
    if (content) content.style.height = content.scrollHeight + 'px';
  }

  // 🔥 CRITICAL: update ALL parent heights
  updateParents(item);
}

function updateParents(item) {
  let parentContent = item.closest('.accordion-content');

  while (parentContent) {
    const parentItem = parentContent.closest('.accordion-item');
    if (!parentItem) break;

    const parent = parentItem.querySelector(':scope > .accordion-content');

    if (parent && parentItem.classList.contains('active')) {
      parent.style.height = parent.scrollHeight + 'px';
    }

    parentContent = parentItem.closest('.accordion-content');
  }
}

// Close all on load
document.querySelectorAll('.accordion-item').forEach(item => {
  item.classList.remove('active');
  const content = item.querySelector(':scope > .accordion-content');
  if (content) content.style.height = '0px';
});
/* FAQ end */

document.querySelectorAll('.pack-selection').forEach(function (pack) {
    const label = pack.querySelector('.pack-label');
    if (label && label.textContent.trim() === 'Title:') {
        pack.style.display = 'none'; // Hides the entire div
    }
});


(function updateLinkUrl() {
  // Check if the element with ID "__ourExperts" exists
  const targetElement = document.querySelector("#__ourExperts");

  // Check if the <a> tag exists
  const linkElement = document.querySelector("#HeaderMenu-expert-advice");

  // If both elements exist, update the URL of the <a> tag
  if (targetElement && linkElement) {
    const baseUrl = window.location.href; // Get the base URL
    // console.log("baseUrl", baseUrl);
    linkElement.href = `${baseUrl}/#__ourExperts`; // Update the href attribute
    linkElement.addEventListener("click", (event) => {
      event.preventDefault(); // Prevent default link behavior
      targetElement.scrollIntoView({ behavior: "smooth" }); // Smoothly scroll to the target section
    });
  }
})();


document.querySelectorAll('a[href^="#"]').forEach((link) => {
  link.addEventListener("click", (event) => {
    event.preventDefault(); // Prevent default link behavior
    const targetId = link.getAttribute("href").substring(1); // Get the target ID
    const targetElement = document.getElementById(targetId); // Find the target element

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" }); // Smooth scroll to the target element
    }
  });
});

